// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","contents":"Footer_contents__r65Ce","items":"Footer_items__u3TyI","logo":"Footer_logo__+JiYo"};